import React, { FC } from 'react';
import { View } from 'react-native';

import { Body1Bold, Title3 } from '../../../config/designSystem/typography';
import { COLORS } from '../../../config/designSystem/Colors';
import { Chip } from '../../presenters/Chip/Chip';
import { MoodDetailsData } from './ContainMoodDetails';
import { QuestionSessionBodyPresentationProps } from '../../QuestionSessions/QuestionSessionBody/config';
import { SPACING } from '../../../config/designSystem/Spacing';
import { useDiaryMaxWidth } from '../ui/useDiaryMaxWidth';

/**
 * figma: Mood Diary (Last step) (Activities & Challenges pt1)
 * Feeling chips and "your day in a few keywords" chips.
 */
export const PresentMoodDetails: FC<QuestionSessionBodyPresentationProps> = ({
  questionText,
  data,
}) => {
  const maxWidth = useDiaryMaxWidth();
  const mood = (data || {}) as MoodDetailsData;

  if (!mood.feelingOptions) {
    return null;
  }

  return (
    <View style={{ alignItems: 'center', paddingHorizontal: SPACING['sp-16'] }}>
      <View style={{ width: '100%', maxWidth, rowGap: SPACING['sp-24'] }}>
        <View style={{ rowGap: SPACING['sp-16'], alignItems: 'center' }}>
          <Title3 align={true}>{questionText}</Title3>
          <View
            style={{ width: 90, height: 3, borderRadius: 2, backgroundColor: COLORS.content.accent }}
          />
        </View>
        <View style={{ rowGap: SPACING['sp-12'] }}>
          <Body1Bold>{mood.feelingsTitle}</Body1Bold>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: SPACING['sp-8'] }}>
            {mood.feelingOptions.map(option => (
              <Chip
                key={option.key}
                variant="soft"
                label={option.label}
                selected={option.selected}
                onPress={() => mood.onToggleFeeling(option.key)}
              />
            ))}
          </View>
        </View>
        <View style={{ rowGap: SPACING['sp-12'] }}>
          <Body1Bold>{mood.keywordsTitle}</Body1Bold>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: SPACING['sp-8'] }}>
            {mood.keywordOptions.map(option => (
              <Chip
                key={option.key}
                variant="soft"
                label={option.label}
                selected={option.selected}
                onPress={() => mood.onToggleKeyword(option.key)}
              />
            ))}
          </View>
        </View>
      </View>
    </View>
  );
};
